import React from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  TableCell,
  Paper,
  TableBody,
  Avatar,
} from "@mui/material";
import moment from "moment";
import { useDispatch } from "react-redux";
import { openLeadExpandModal } from "../../../../../components/LeadPopup/hooks/useLeadCard";

const StyledTableCellHead = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  lineHeight: "18px",
  backgroundColor: "#073E53",
  color: "#FFFFFF",
  textTransform: "capitalize",
  fontWeight: "400",
  fontSize: 14,
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "15px",
}));

const StyledTableCellBody = styled(TableCell)(({ theme }) => ({
  fontFamily: "Poppins",
  fontWeight: "400",
  fontSize: "12px",
  color: "#667085",
  padding: theme.spacing(1),
  paddingTop: "15px",
  paddingBottom: "10px",
}));
function RevenuePaidTab(props: any) {
  const { tableData, id } = props;
  const dispatch = useDispatch();
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          height: "calc(100vh - 100px)",
          overflowY: "scroll",
          boxShadow: "none",
          flexGrow: 1,
          width: "100%",
          maxHeight: "calc(100vh - 220px)",
          minHeight: "calc(100vh - 220px)",
        }}
      >
        <Table sx={{ minWidth: 700 }}>
          <TableHead
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 999,
            }}
          >
            <TableRow>
              <StyledTableCellHead
                sx={{
                  minWidth: 250,
                }}
              >
                Name{" "}
                {`${tableData?.length > 0 ? `(${tableData?.length})` : ""}`}
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 150,
                }}
              >
                Phone Number
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 200,
                }}
              >
                Email
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 200,
                }}
              >
                Course
              </StyledTableCellHead>

              <StyledTableCellHead
                sx={{
                  minWidth: 200,
                }}
              >
                Batch
              </StyledTableCellHead>

              <StyledTableCellHead
                sx={{
                  minWidth: 170,
                }}
              >
                Transaction Amount
              </StyledTableCellHead>
              {/* 		<StyledTableCellHead
								sx={{
									minWidth: 170,
									position: 'sticky',
									top: 0,
									background: '#f5f5f5',
									zIndex: 1,
								}}>
								Invoice Number
							</StyledTableCellHead> */}
              {/* <StyledTableCellHead
                sx={{
                  minWidth: 170,
                 
                }}
              >
                CGST
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 170,
                 
                }}
              >
                SGST
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 170,
                 
                }}
              >
                IGST
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 170,
                 
                }}
              >
                VAT
              </StyledTableCellHead> */}
              {/* <StyledTableCellHead
                sx={{
                  minWidth: 170,
               
                }}
              >
                Adjustment
              </StyledTableCellHead> */}
              <StyledTableCellHead
                sx={{
                  minWidth: 250,
                }}
              >
                Transaction date and time
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 100,
                }}
              >
                Type
              </StyledTableCellHead>
              <StyledTableCellHead
                sx={{
                  minWidth: 130,
                }}
              >
                Payment mode
              </StyledTableCellHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.map((report: any, index: any) => (
              <TableRow key={index}>
                <StyledTableCellBody>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      textTransform: "capitalize",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      openLeadExpandModal(
                        id,
                        report?.studentContact,
                        report?.studentEmail,
                        report?.enquiryId,
                        dispatch,
                        "payment"
                      );
                    }}
                  >
                    <div>
                      <Avatar
                        sx={{
                          width: "28px",
                          height: "28px",
                          borderRadius: "50%",
                          fontSize: "11px",
                          background: "#EEEEF4",
                          border: "1px solid #F5F5F7",
                          fontFamily: "Poppins",
                          fontWeight: "500",
                          color: "#667085",
                          textTransform: "uppercase",
                        }}
                      >
                        {report?.studentFirstName?.charAt(0) +
                          report?.studentLastName?.charAt(0)}
                      </Avatar>
                    </div>
                    <div>
                      {`${
                        report?.studentFirstName + " " + report?.studentLastName
                      }`}
                    </div>
                  </div>
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {report?.studentContact
                    ? `+${report?.contactCountryCode || "91"} ${
                        report?.contactCountryCode
                          ? report?.studentContact?.replace(
                              report?.contactCountryCode,
                              ""
                            )
                          : report?.studentContact?.startsWith("91")
                          ? report?.studentContact?.replace("91", "")
                          : report?.studentContact
                      }`
                    : "-"}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {report?.studentEmail}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  {report?.courseName}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  {report?.batchName}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    fontSize: "16px",
                    color: "#1877F2",
                    fontFamily: "Roboto",
                  }}
                >
                  {report?.branchCurrency + "" + report?.amountReceived}
                </StyledTableCellBody>
                {/* 		<StyledTableCellBody
									sx={{
										fontSize: '16px',
										color: '#1877F2',
										fontFamily: 'Roboto',
									}}>
									{'-'}
								</StyledTableCellBody> */}
                {/* <StyledTableCellBody
                  sx={{
                    fontSize: "16px",
                    color: "#1877F2",
                    fontFamily: "Roboto",
                  }}
                >
                  {report?.CGST ? report?.CGST : "-"}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    fontSize: "16px",
                    color: "#1877F2",
                    fontFamily: "Roboto",
                  }}
                >
                  {report?.SGST ? report?.SGST : "-"}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    fontSize: "16px",
                    color: "#1877F2",
                    fontFamily: "Roboto",
                  }}
                >
                  {report?.IGST ? report?.IGST : "-"}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    fontSize: "16px",
                    color: "#1877F2",
                    fontFamily: "Roboto",
                  }}
                >
                  {report?.VAT ? report?.VAT : "-"}
                </StyledTableCellBody> */}
                {/* <StyledTableCellBody
                  sx={{
                    fontSize: "16px",
                    color: "#1877F2",
                    fontFamily: "Roboto",
                  }}
                >
                  {report?.adjustment ? report?.adjustment : "-"}
                </StyledTableCellBody> */}

                <StyledTableCellBody>
                  {moment(report?.transactionDateTime).format(
                    "DD/MM/YYYY,  hh:mm A"
                  )}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    textTransform: "capitalize",
                    color:
                      report?.paymentMode === "OFFLINE" ? "#EC3939" : "#11C89B",
                    fontWeight: "600",
                  }}
                >
                  {report?.paymentMode}
                </StyledTableCellBody>
                <StyledTableCellBody
                  sx={{
                    textTransform: "capitalize",
                  }}
                >
                  {report?.paymentSource}
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default RevenuePaidTab;
